export default {
  GET_MY_ROOMS: (state) => state.myRooms,
  IS_LOADING_MY_ROOMS: (state) => state.loading,
  GET_MY_ROOMS_ERROR: (state) => state.error,
};
